import GrandChildPageSchema from './pages/GrandChildPageSchema'
import LandingPageSchema from './pages/LandingPageSchema'
import ProductPageSchema from './pages/ProductPageSchema'
import FAQPageSchema from './pages/FAQPageSchema'

/**
 * Gets the schema for a page based on the page type
 * @param {Object} appContext - Application context containing page data, header, and footer
 * @returns {Object[]|null} Schema objects or null when no schemas are available
 */
export default function getSchemaForPage(appContext) {
    const { data, header, footer } = appContext
    
    if (!data || !data.ContentType || !Array.isArray(data.ContentType)) {
        return null
    }

    const schemas = []

    const pageType = data.ContentType[data.ContentType.length - 1]
    let pageSpecificSchema = null

    // Page schemas
    switch (pageType) {
        case 'LandingPage':
            pageSpecificSchema = LandingPageSchema(data, header, footer)
            break
        case 'GrandChildPage':
            pageSpecificSchema = GrandChildPageSchema(data)
            break
        case 'ProductPage':
            pageSpecificSchema = ProductPageSchema(data)
            break
    }

    if (pageSpecificSchema != null) {
        schemas.push(pageSpecificSchema)
    }

    // FAQ schema can coexist with page-specific schema.
    const frequentlyAskedQuestionsSchema = FAQPageSchema(data)
    if (frequentlyAskedQuestionsSchema != null) {
        schemas.push(frequentlyAskedQuestionsSchema)
    }

    return schemas.length ? schemas : null
}